import { type BoilerRoom, type Building, type HeatingNetwork } from "@eisox/api/core-api";
import { type Drawer } from "@eisox/design-system";

import * as ItemDrawer from "~/components/item-drawer";
import { m } from "~/paraglide/messages";
import { useBuildingContext } from "~/providers/building.provider";
import type { Permission } from "~/types/auth.type";
import type { EnhancedValve } from "~/types/valve.type";

import { ValveDetailActions } from "./valve-detail-actions";
import { ValveDetailContent } from "./valve-detail-content";

interface ValvesDrawerProps extends Drawer.DrawerProps {
  building: Building;
  boilerRooms: BoilerRoom[];
  heatingNetworks: HeatingNetwork[];
  valves: EnhancedValve[];
  permissions: Permission;
  defaultSelectedValveId?: string;
}

export const ValvesDrawer: React.FC<ValvesDrawerProps> = ({
  building,
  boilerRooms,
  heatingNetworks,
  valves,
  permissions,
  defaultSelectedValveId,
  children,
  ...props
}) => {
  const { canSeeInstallerWarnings } = useBuildingContext("ValvesDrawer");

  return (
    <ItemDrawer.Root {...props} items={valves} defaultSelectedItemId={defaultSelectedValveId}>
      <ItemDrawer.Trigger asChild>{children}</ItemDrawer.Trigger>
      <ItemDrawer.Content<EnhancedValve> title={m.valves_list()} select={{ title: "mac", subtitle: "gatewayName" }}>
        {valve => (
          <>
            <ValveDetailContent
              valve={valve}
              building={building}
              boilerRooms={boilerRooms}
              heatingNetworks={heatingNetworks}
              valves={valves}
              permissions={permissions}
              canSeeInstallerWarnings={canSeeInstallerWarnings}
              interactive
            />

            <ValveDetailActions building={building} valve={valve} valves={valves} permissions={permissions} />
          </>
        )}
      </ItemDrawer.Content>
    </ItemDrawer.Root>
  );
};
